<template>
  <SpotifyPlaylistTracks client_name="DY" />
</template>

<script>
import axios from "axios";
import $ from "jquery";
import SpotifyPlaylistTracks from "@/components/music_library/SpotifyPlaylistTracks.vue";

export default {
  name: "MIDMusicLibrarySpotifyPlaylistTracks",
  components: { SpotifyPlaylistTracks },
  data() {
    return {};
  },
  mounted() {
    // this.getEventsList();
  },
  computed: {},
  created() {},
  methods: {
    getEventsList() {
      // console.log(JSON.parse(window.localStorage.getItem("user")).access_token)
      axios
        .get("event/events", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: "MID",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.events = response.data;
        });
    },
  },
};
</script>


<!-- <template>
  <div class="musiclibrary spotify-playlists container-fluid">
    <div class="container-fluid">
      <div class="row" id="">
        <div class="col-md-12">
          <div class="card card-transparent-background">
            <div class="card-header card-header-icon row">
              <div class="col-12 pl-0">
                <h4 class="card-title">Playlist 2 (20 mins)</h4>
              </div>
            </div>
          </div>
          <b-card no-body id="musicLibrarySpotifyCard" class="p-3">
            <b-card-body class="p-md-3 pt-md-0 p-0 pt-3">
              <dataset
                v-slot="{ ds }"
                :ds-data="tracks"
                :ds-filter-fields="{
                  title: startsWithFilter,
                }"
                :ds-search-in="['title', 'album']"
                :ds-search-as="{ searchTest }"
              >
                <div class="row mb-2" :data-page-count="ds.dsPagecount">
                  <div class="col-xl-7 col-md-6">
                    <b-input-group class="input-group-search">
                      <template #prepend>
                        <font-awesome-icon
                          icon="fa-solid fa-magnifying-glass"
                          size="lg"
                        />
                      </template>
                      <dataset-search ds-search-placeholder="Search"
                    /></b-input-group>
                  </div>
                  <div class="col-xl-5 col-md-6">
                    <dataset-show
                      :ds-show-entries="5"
                      class="showEntriesSelectContainer float-right"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="row my-2">
                      <div class="col">
                        <h3 class="media-category-title">{{ title }}</h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-responsive" style="height: 450px">
                      <table class="table doomYogaTable doomYogaPlaylistTable">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th>Title</th>
                            <th>Album</th>
                            <th>Duration</th>
                          </tr>
                        </thead>
                        <dataset-item tag="tbody">
                          <template #default="{ row, rowIndex }">
                            <tr>
                              <td scope="row">{{ rowIndex + 1 }}</td>
                              <td>
                                <img
                                  v-if="row.cover_image == null"
                                  src="@/assets/images/doom-yoga/doomyoga-music.png"
                                />
                                <img v-else :src="row.cover_image" />
                                {{ row.title }}
                              </td>
                              <td>{{ row.album }}</td>
                              <td>{{ row.time_duration }}</td>
                            </tr>
                          </template>
                          <template #noDataFound>
                            <tr>
                              <td colspan="4">
                                <p class="text-center datasetNoFoundP mb-0">
                                  No data found
                                </p>
                              </td>
                            </tr>
                          </template>
                        </dataset-item>
                      </table>
                    </div>
                  </div>
                </div>

                <div
                  class="
                    d-flex
                    flex-md-row flex-column
                    justify-content-between
                    align-items-center
                  "
                >
                  <dataset-info class="mb-2 mb-md-0 datasetInfo" />
                  <dataset-pager />
                </div>
              </dataset>

              <div class="row">
                <div class="col-md-12">
                  <div class="row my-2">
                    <div class="col">
                      <h3 class="media-category-title">Other Playlists</h3>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="row my-2">
                    <div class="col">
                      <VueSlickCarousel v-bind="settings">
                        <div
                          v-for="item in playlists_list"
                          :key="item.id"
                          class=""
                        >
                          <router-link
                            :to="
                              '/doom_yoga/music_library/spotify_playlist/' +
                              item.id
                            "
                            class="card-link eventLink"
                          >
                            <MediaCard
                              class="media-card-item"
                              :title="item.title"
                              :duration="item.time_duration"
                              :img_src="item.cover_image"
                              media_type="music"
                              music_type="spotify"
                            />
                          </router-link>
                        </div>
                      </VueSlickCarousel>
                    </div>
                  </div>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
import MediaCard from "../media/MediaCard.vue";
import AddMediaCard from "../media/AddMediaCard.vue";
import AddVideo from "../media/AddVideo.vue";

import {
  filterList,
  clone,
  isoDateToEuroDate,
  searchAsEuroDate,
} from "vue-dataset/docs/.vuepress/utilities";
import { debounce, fieldFilter, findAny } from "vue-dataset/src/helpers";

export default {
  name: "SpotifyPlaylistTracks",
  components: { MediaCard, AddMediaCard, AddVideo },
  data() {
    return {
      datasetI18n: {
        show: "Show",
        entries: "entries",
        previous: "Previous",
        next: "Next",
        showing: "Showing",
        showingTo: "to",
        showingOf: "of",
        showingEntries: "entries",
      },
      settings: {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        swipeToSlide: true,
        responsive: [
          //col-xl-2 col-lg-3 col-md-3 col-6
          {
            breakpoint: 1024.5,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      },
      title: "Surround to Sound and Silence",
      tracks: [
        {
          id: 1,
          title: "Track 1",
          album: "Album 1",
          time_duration: "14 min 30 sec",
          cover_image: null,
        },
        {
          id: 2,
          title: "Track 2",
          album: "Album 1",
          time_duration: "14 min 30 sec",
          cover_image: null,
        },
        {
          id: 3,
          title: "Track 3",
          album: "Album 1",
          time_duration: "14 min 30 sec",
          cover_image: null,
        },
        {
          id: 4,
          title: "Track 4",
          album: "Album 1",
          time_duration: "14 min 30 sec",
          cover_image: null,
        },
        {
          id: 5,
          title: "Track 5",
          album: "Album 2",
          time_duration: "14 min 30 sec",
          cover_image: null,
        },
        {
          id: 6,
          title: "Track 6",
          album: "Album 2",
          time_duration: "14 min 30 sec",
          cover_image: null,
        },
        {
          id: 7,
          title: "Track 7",
          album: "Album 3",
          time_duration: "14 min 30 sec",
          cover_image: null,
        },
      ],
      playlists_list: [
        {
          id: 1,
          title: "Playlist 1",
          time_duration: "14 min 30 sec",
          cover_image: null,
        },
        {
          id: 2,
          title: "Playlist 2",
          time_duration: "8 min 30 sec",
          cover_image: "https://placekitten.com/250/250",
        },
        {
          id: 3,
          title: "Playlist 3",
          time_duration: "10 min 30 sec",
          cover_image: "https://placekitten.com/250/250",
        },
        {
          id: 4,
          title: "Playlist 4",
          time_duration: "30 min 30 sec",
          cover_image: "https://placekitten.com/250/250",
        },
        {
          id: 5,
          title: "Playlist 5",
          time_duration: "45 min 30 sec",
          cover_image: "https://placekitten.com/250/250",
        },
        {
          id: 1,
          title: "Playlist 1",
          time_duration: "14 min 30 sec",
          cover_image: null,
        },
        {
          id: 2,
          title: "Playlist 2",
          time_duration: "8 min 30 sec",
          cover_image: "https://placekitten.com/250/250",
        },
        {
          id: 3,
          title: "Playlist 3",
          time_duration: "10 min 30 sec",
          cover_image: "https://placekitten.com/250/250",
        },
        {
          id: 4,
          title: "Playlist 4",
          time_duration: "30 min 30 sec",
          cover_image: "https://placekitten.com/250/250",
        },
        {
          id: 5,
          title: "Playlist 5",
          time_duration: "45 min 30 sec",
          cover_image: "https://placekitten.com/250/250",
        },
        {
          id: 1,
          title: "Playlist 1",
          time_duration: "14 min 30 sec",
          cover_image: null,
        },
        {
          id: 2,
          title: "Playlist 2",
          time_duration: "8 min 30 sec",
          cover_image: "https://placekitten.com/250/250",
        },
        {
          id: 3,
          title: "Playlist 3",
          time_duration: "10 min 30 sec",
          cover_image: "https://placekitten.com/250/250",
        },
        {
          id: 4,
          title: "Playlist 4",
          time_duration: "30 min 30 sec",
          cover_image: "https://placekitten.com/250/250",
        },
        {
          id: 5,
          title: "Playlist 5",
          time_duration: "45 min 30 sec",
          cover_image: "https://placekitten.com/250/250",
        },
      ],
      selected_category: null,

      onlineFilter: "",
      selected: 5,
      startsWith: "",
      playlist_title: null,
      playlist_url: null,
      playlist_cover_image: null,
    };
  },
  mounted() {
  },
  computed: {},
  created() {
    this.startWithInput = debounce((e) => {
      this.startsWith = e.target.value;
    }, 100);
  },
  methods: {
    filterList,
    isoDateToEuroDate,
    searchAsEuroDate,
    // updateData() {
    //   const updatedList = clone(tracks).slice(5, 5);
    //   this.tracks = updatedList;
    // },
    startsWithFilter(value) {
      return (
        value === null ||
        value.toLowerCase().startsWith(this.startsWith.toLowerCase())
      );
    },
    searchTest(value, searchString, rowData) {
      console.log(value);
      console.log(searchString);
      console.log(rowData);
      console.log(searchString === value);
      return searchString === value;
    },
    fieldFilter,
    onSubmit(event) {
      console.log(event);
      console.log(this.playlist_title);
      console.log(this.playlist_url);
      console.log(/[^/]*$/.exec(this.playlist_url)[0]);
    },
  },
};
</script> -->



// WEBPACK FOOTER //
// src/components/doom_yoga/music_library/SpotifyPlaylistTracks.vue